<template>
  <div>
    <feather-icon icon="SaveIcon" svgClasses="h-6 w-6 hover:text-primary cursor-pointer" @click="saveRecord" />
    <feather-icon icon="TrashIcon" svgClasses="h-6 w-6 hover:text-primary cursor-pointer ml-3" @click="clearAlltenndeeScore" />
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: 'CellRendererActions',
  methods: {
    saveRecord () {
      //console.log(this.params.data);
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/updateLeaderboard", this.params.data)
        .then(res => {
          this.$vs.loading.close();
          if(res.status == 200){
            this.$vs.notify({
              position: "center",
              color: 'success',
              text: `${this.params.data.ActionName} data updated`
            })
          }
          else{
            this.$vs.notify({
              position: "center",
              color: 'warning',
              text: `${this.params.data.ActionName} data not updated!`
            })
          }
        }).catch(err=>{
          this.$vs.loading.close();
          this.$vs.notify({
              position: "center",
              color: 'warning',
              text: `Something went wrong!`
            })
        })
    },
    clearAlltenndeeScore(){
      const { value: text } = Swal.fire({
          title: "This will clear existing Points for all Attendees in the event. Are you sure?",
          input: "text",
          inputPlaceholder: "Type 'clear' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase().trim() == "clear") {
              this.clearRecords();
            } else {
              return "Try again! Please type 'clear' and hit Submit.";
            }
          },
        });
    },
    clearRecords(){
      this.$vs.loading();
      this.$store.dispatch("LeaderboardManagement/clearAlltenndeeScore", 
        {items: [this.params.data.ActionTypeCode], users:[]})
        .then(res => {
          this.$vs.loading.close();
          if(res.status==200){
            this.$vs.notify({
                position: "center",
                color: 'success',
                text: `Score Cleared Successfully.`
              })
          }
          else
          {
            this.$vs.notify({
                position: "center",
                color: 'warning',
                text: `Score Not Cleared!`
              })
          }
        }).catch(err=>{
          this.$vs.loading.close();
          this.$vs.notify({
              position: "center",
              color: 'warning',
              text: `Something went wrong!`
            })
        })
    }
  }
}
</script>
